import { createFileRoute } from '@tanstack/react-router';
import DuplicateLookupView from '../admin/loadboards/duplicates/duplicates-view';
export const Route = createFileRoute('/admin/loadboards/duplicates')({
  component: DuplicateLookupView,
});
